import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useAthleteContext } from '../../context/AthleteContext';
import { BatchComparePanel } from '../../pages/comparison/BatchComparePanel';

/** PWA — dedicated batch workout compare screen (not part of Charts). */
export function MobileBatchComparePage() {
  const { t } = useTranslation();
  const auth = useAuth();
  const { effectiveUserId, isCoach, athletes, coachMenuLocked, selectedAthleteId } = useAthleteContext();

  if (coachMenuLocked) {
    return null;
  }

  const fallbackUserId = effectiveUserId ?? auth.user?.id ?? null;

  return (
    <div className="mobile-screen mobile-batch-page">
      <header className="mobile-batch-page__head">
        <h1 className="mobile-batch-page__title">{t('batchCompare.pageTitle')}</h1>
        <p className="mobile-batch-page__sub">{t('batchCompare.pageSubtitle')}</p>
      </header>
      <BatchComparePanel
        isCoach={isCoach}
        athletes={athletes}
        fallbackUserId={fallbackUserId}
        initialAthleteId={isCoach ? selectedAthleteId : fallbackUserId}
      />
    </div>
  );
}
